import React from "react";
import { useState, useEffect } from "react";
import {
   Pie,
   PieChart,
   Cell,
   ComposedChart,
   Bar,
   Line,
   BarChart,
   AreaChart,
   Area,
   XAxis,
   YAxis,
   CartesianGrid,
   Tooltip,
   ReferenceLine,
   Legend,
   ResponsiveContainer,
   LabelList,
} from "recharts";
import {
   api,
   formatCurrency,
   getDateSpanArray,
   getStaticData,
   httpPost,
   parseOODate,
   parsePreisliste,
   sortArrayOfObjects,
} from "../pureFunctions";
import { colorPalette100, header, host, averageString } from "../globalVariables";
import { useConfig } from "../ConfigContext";
import { Form, Col, Button, Row, Table } from "react-bootstrap";
import DatePicker from "react-datepicker";
import { getAppointments } from "../networkFunctions";
import { values } from "lodash";
import MySelect from "../MySelect";
import { CustomTermineLabel, CustomTooltip } from "./CustomRechartUtils";
import VerkaufsdatenPreisSpanne from "./VerkaufsdatenPreisSpanne";

const tableHeader = [
   { key: "objektnr_extern", value: "Objektnummer" },
   { key: "objektBezeichnung", value: "Objektbezeichnung" },
   { key: "einkaeufer", value: "Einkäufer" },
   { key: "benutzer", value: "Verkäufer" },
   { key: "quelle", value: "Quelle" },
   { key: "verkaufsstatus", value: "Status" },
   { key: "verkauftFur", value: "Verkauft für" },
   { key: "kaufpreis", value: "ursp. Preis" },
   {key: "vollmachtsdatum", value: "Vollmachtsdatum"},
   {key: "onlinestellungsdatum", value: "Onlinestellungssdatum"}
];

const lsOptionKey = "VerkaufsdatenOpt";
const initialFilterParams = {
   dateField: "erstellt_am",
   dateField2: "",
   sortField: "",
   startDate: new Date("01.01." + new Date().getFullYear()),
   endDate: new Date("12.31." + new Date().getFullYear()),
   startDate2: new Date("01.01." + new Date().getFullYear()),
   endDate2: new Date("12.31." + new Date().getFullYear()),
   startDateTermin: new Date("01.01." + new Date().getFullYear()),
   endDateTermin: new Date("12.31." + new Date().getFullYear()),
   terminArten: "",
   quelle: [],
   // terminArten: [],
   einkaeufer: [],
   benutzer: [],
   vollmachtsdatum: false,
   status2: [],
};

export default function VerkaufsdatenTable({ users,oOFields, tableData, setTableData }) {
   const config = useConfig();
   const [showOnlyDone, setShowOnlyDone] = useState(false);
   const [showDone, setShowDone] = useState(true);
      const [sortKey, setSortKey] = useState("objektnr_extern");
   

   return (
      <div>
         {tableData && (
            <div className="m-5" style={{ maxHeight: "80vh", overflow: "auto" }}>
               <Table striped bordered hover /* responsive */>
                  <thead style={{ position: "sticky", top: 0 }}>
                     <tr>
                        <th style={{ position: "sticky", top: 0 }}>
                           {false&&config.company === "baur" && (
                              <>
                                 {" "}
                                 <Button
                                    variant="dark"
                                    onClick={() => {
                                       setShowDone((prev) => !prev);
                                    }}
                                 >
                                    👁
                                 </Button>{" "}
                                 <Button
                                    style={{ background: "#faf" }}
                                    onClick={() => {
                                       setShowOnlyDone((prev) => !prev);
                                    }}
                                 >
                                    👁
                                 </Button>
                              </>
                           )}
                        </th>
                        {tableHeader.map((item) => {
                           return (
                              <th
                                 style={{
                                    ...(item.key === sortKey ? { backgroundColor: "#333", color: "#fff" } : {}),
                                    position: "sticky",
                                    top: 0,
                                 }}
                                 onClick={() => {
                                    let sortDirection = item.key === sortKey ? -1 : 1;
                                    setTableData((prev) => {
                                       return sortArrayOfObjects(prev, item.key, sortDirection);
                                    });
                                    setSortKey(item.key);
                                 }}
                              >
                                 {item.value}
                              </th>
                           );
                        })}
                        <th style={{ position: "sticky", top: 0 }}> </th>
                     </tr>
                  </thead>
                  <tbody>
                     {tableData.map((zeile, index) => {
                        let showZeile = true;
                        if (!showDone) {
                           showZeile = !(
                              zeile.annikasFeld ||
                              (zeile.vollmachtsdatum && zeile.onlinestellungsdatum && zeile.quelle)
                           );
                        }
                        if (showOnlyDone) {
                           showZeile = zeile.vollmachtsdatum && zeile.onlinestellungsdatum && zeile.quelle;
                        }

                        if (showZeile)
                           return (
                              <tr key={index}>
                                 <td
                                    className="text-center"
                                    /* style={{
                                       ...(zeile.vollmachtsdatum && zeile.onlinestellungsdatum && zeile.quelle
                                          ? { boxShadow: "inset 0 0 10px 4px #fef" }
                                          : {}),
                                       ...(zeile.annikasFeld ? { background: "#eff", color: "#000" } : {}),
                                    }} */
                                 >
                                    {index + 1}
                                 </td>
                                 {tableHeader.map((item) => {
                                    let columnText;

                                    if (item.key === "einkaeufer")
                                       columnText =
                                          zeile[item.key] &&
                                          (users?.userObject?.[zeile[item.key]]?.Name ?? zeile[item.key]);
                                    else if (item.key === "verkaufsstatus") {
                                       columnText =
                                          oOFields?.estate?.status2?.permittedvalues[zeile[item.key]] ??
                                          zeile[item.key];
                                    } else if (item.key === "benutzer")
                                       columnText =
                                          zeile[item.key] &&
                                          (users?.userObject?.[zeile[item.key]]?.Name ?? zeile[item.key]);
                                    else if (item.key === "verkauftFur" || item.key === "kaufpreis")
                                       columnText = formatCurrency(zeile[item.key]);
                                    else if (item.key === "quelle" && config.company === "bender") {
                                       columnText =
                                          zeile[item.key]
                                             ?.map(
                                                (quellItem) =>
                                                   oOFields?.estate?.[config.estate.quelle]?.permittedvalues[quellItem],
                                             )
                                             ?.join(", ") ?? "";
                                    } else {
                                       columnText = zeile[item.key];
                                    }
                                    return <td>{columnText}</td>;
                                 })}
                                 <td className="text-center">
                                    <a
                                       title="zur Einkaufsterminkachel"
                                       href={`/datenblatt?estateid=${zeile.estateId}&stufe=einkaufstermin&kachel=einkaufstermin`}
                                       target="_blank"
                                    >
                                       BT
                                    </a>{" "}
                                    <a
                                       title="zur Vollmachtskachel"
                                       href={`/datenblatt?estateid=${zeile.estateId}&stufe=vollmacht&kachel=vollmachten`}
                                       target="_blank"
                                    >
                                       VM
                                    </a>{" "}
                                    <a
                                       title="zur Onlinestellungskachel"
                                       href={`/datenblatt?estateid=${zeile.estateId}&stufe=expoerstellung&kachel=expo_onlinestellung`}
                                       target="_blank"
                                    >
                                       EE
                                    </a>
                                 </td>
                              </tr>
                           );
                     })}
                  </tbody>
               </Table>
            </div>
         )}
      </div>
   );
}
